export default "__VITE_ASSET__CsMxLZa1__"